import React from 'react'

export const NewMessagesLine = props => {
  const { classes } = props

  return (
    <div className={classes.container} ref={props.firstUnreadMessageRef}>
      <p>Unread messages</p>
    </div>
  )
}
